import { createResourceBuilder } from '../resource';
import { EResourceMethod } from '../models/IPermission';

export const productToolResources = {
  getTools: createResourceBuilder('/drmrust/v2.1/admin/products/packages/tools', EResourceMethod.Get),
  createTool: createResourceBuilder('/drmrust/v2.1/admin/products/packages/tools', EResourceMethod.Post),
  updateTool: createResourceBuilder(
    '/drmrust/v2.1/admin/products/packages/tools/:tool_id',
    EResourceMethod.Put,
    (tool_id: string) => ({ tool_id })
  ),
  deleteTool: createResourceBuilder(
    '/drmrust/v2.1/admin/products/packages/tools/:tool_id',
    EResourceMethod.Delete,
    (tool_id: string) => ({ tool_id })
  ),
};
